import { makeAutoObservable } from "mobx";
import { eventsStore } from "./Events";
import { filterTagsGl } from "./FilterTags";
import { Settings, settingsGl } from "./Settings";
import { adminDateFilterGl } from "./AdminDateFilter";
import { DateSerivce } from "../services/DateService";
import { tagsStore } from "./Tags";
export interface IFilterDate {
  name: string;
  date: string;
  dateSec: number;
}
export class FilterDates {
  public _listOfSelecedDates: IFilterDate[] = [];

  public set listOfSelecedDates(val: IFilterDate[]) {
    this._listOfSelecedDates = val;
  }
  public get listOfSelecedDates() {
    if (this._listOfSelecedDates.length == 0) {
      return this.remainingDays;
    }
    return this._listOfSelecedDates;
  }

  public remainingDays = DateSerivce.getDaysForPanel();

  constructor() {
    makeAutoObservable(this);
    // this.listOfSelecedDates = [...[...this.remainingDays].splice(0, 2)];
    // this.listOfSelecedDates = [...[...this.remainingDays]];
  }

  /**
   * Выбрать все дни
   */
  public async onPickAllDays() {
    filterTagsGl.listOfSelectedTags = [];
    this.listOfSelecedDates = [];
    await this.reloadListOfEvents();
  }

  /**
   *
   * @param date1
   * @param date2
   */
  public static isTheSameDay(date1Sec: number, date2Sec: number): boolean {
    return (
      new Date(date1Sec * 1000).toLocaleString().split(",")[0] ===
      new Date(date2Sec * 1000).toLocaleString().split(",")[0]
    );
  }
  public async onPickDate(date: IFilterDate) {
    filterTagsGl.listOfSelectedTags = [];
    settingsGl.currentPage = 0;
    settingsGl.hasMore = true;
    const hasDate = this._listOfSelecedDates.filter((el) =>
      FilterDates.isTheSameDay(el.dateSec, date.dateSec)
    ).length;
    if (hasDate) {
      this.listOfSelecedDates = this._listOfSelecedDates.filter(
        (el) => el.dateSec !== date.dateSec
      );
    } else {
      this._listOfSelecedDates = [date];
      //множетсвенный выбор
      // this._listOfSelecedDates.push(date);
    }
    await this.reloadListOfEvents();
  }

  /**
   * Перезагрузить список событий со спицификой FilterDates
   */
  public async reloadListOfEvents() {
    let finalDates = [];
    if (!this.listOfSelecedDates.length) {
      finalDates = [...this.remainingDays];
    } else {
      finalDates = this.listOfSelecedDates;
    }
    eventsStore.listOfPreviewEvents = [];
    tagsStore.tagsIsLoading = true;
    settingsGl.scrollReload = !settingsGl.scrollReload;
    await eventsStore.getListOfPreviewEvents(
      11,
      11,
      filterTagsGl.listOfSelectedTags.map((el) => el.id),
      0,
      Settings.chunkLength,
      settingsGl.showOnlyUnique,
      settingsGl.currentDayFilter,
      {},
      finalDates,
      Array.from(adminDateFilterGl.listOfSelectedDates)
    );
    tagsStore.tagsIsLoading = false;
  }
}
export const filterDatesGl = new FilterDates();
